import { useState } from "react";
import { Field } from "formik";
import { deleteIcon } from "../../../assets/icons";
import { FIELDS } from "../datamodels.constants";
import { HANDLE_TYPES, EMPTY_STRING, INDEX } from "../../../constants";

const TYPE = "type";
const handleTypeOptions = ["trigger", "object", "list"];
const { TRIGGER } = HANDLE_TYPES;
const {
  OUTPUTS,
  OUTPUT_MODEL_TYPE,
  MODEL_NAME,
  MODEL_DEFINITION,
  PREDEFINED,
  CUSTOM,
} = FIELDS;
const { FIRST } = INDEX

const OutputLinkPoints = (props) => {
  const { outputLinks, handleChange, removeHandle, currentNode} = props;
  const [defaultValue, setDefaultValue] = useState(EMPTY_STRING); 

  const handleOutPutLinkPointName = (e, outputKey, index) => {
    let defaultOutputLinkPointName = index === FIRST ? `${outputKey}` : `${outputKey + index}`;
    if (!e.target.value) {
      setDefaultValue(defaultOutputLinkPointName);
      return defaultOutputLinkPointName;
    }
  };

  const handleOnChange = (e, key) => {
    setDefaultValue(EMPTY_STRING);
    handleChange(e, OUTPUTS, key);
  };

  return (
    <>
      {!!outputLinks.length && (
        <div className="border-b border-gray-700 text-base font-medium text-gray-50 block">
          {outputLinks.map((eachOutput, index) => {
            return (
              <div
                className="flex gap-1 mt-1 flex-wrap text-sm"
                key={eachOutput.key}
              >
                <div className="flex flex-col gap-1 w-full">
                  <label>Name</label>
                  <Field
                    className="form-control"
                    type="text"
                    name={eachOutput.key}
                    value={eachOutput.name || defaultValue}
                    placeholder={eachOutput.key}
                    onChange={(e) => handleOnChange(e, eachOutput.key)}
                    onBlur={(e) => {
                      if (!e.target.value)
                        eachOutput.name = handleOutPutLinkPointName(e, eachOutput.key, index);
                    }}
                  />
                </div>
                {eachOutput.canChangeType && (
                  <div className="flex flex-col gap-1 text-sm w-full">
                    <label>Type</label>
                    <Field
                      as="select"
                      className="form-control capitalize"
                      name={eachOutput.key}
                      value={eachOutput.type}
                      onChange={(e) => {
                        const updateField = {};
                        let child;

                        const outputModelType = currentNode.config.find(
                          (config) => config.key === OUTPUT_MODEL_TYPE
                        );
                        if (outputModelType.defaultValue === PREDEFINED)
                          child = MODEL_NAME;
                        else if (outputModelType.defaultValue === CUSTOM)
                          child = MODEL_DEFINITION;

                        if (e.target.value === TRIGGER)
                          updateField.disable = [OUTPUT_MODEL_TYPE, child];
                        else updateField.enable = [OUTPUT_MODEL_TYPE, child];

                        handleChange(
                          e,
                          OUTPUTS,
                          eachOutput.key,
                          TYPE,
                          updateField
                        );
                      }}
                    >
                      {handleTypeOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Field>
                  </div>
                )}
                {eachOutput.custom && (
                  <img
                    src={deleteIcon}
                    onClick={() => removeHandle(eachOutput.key, OUTPUTS)}
                    width="20"
                    alt="delete"
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default OutputLinkPoints;
